import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

import { useFetchSubscription } from '../../../hooks';
import { Typography } from '@mui/material';
import { VpButton } from '../../components';
import { VpInput } from '../../inputs';
import { VpStripeElementsWrapper } from '../../wrappers';
import AddCardDialogContent from '../../dialogs/VpAddCardDialog/AddCardDialogContent';

// styles
const gridStyles = {
  display: 'grid',
  gridAutoFlow: 'column',
  justifyContent: 'space-between',
  marginBottom: '10px'
};

export const VpStripePaymentMethod = ({ onUpdateClick, onClose }) => {
  const { data } = useFetchSubscription();

  const hasCard = !!data?.card;
  const cardValue = `${data?.card?.brand} ending in ${data?.card?.last4}`;

  return (
    <Box>
      <Box sx={gridStyles}>
        <Typography>Payment Method</Typography>
        {hasCard && (
          <VpButton onClick={onUpdateClick} size="large" inline disableBackground underline>
            Update Card
          </VpButton>
        )}
      </Box>
      {hasCard ? (
        <VpInput disabled name="paymentMethod" fullWidth value={cardValue} />
      ) : (
        //'No payment method on record'
        <VpStripeElementsWrapper>
          <AddCardDialogContent onClose={onClose} isUpdate={false} closeOnSuccess={false} />
        </VpStripeElementsWrapper>
      )}
    </Box>
  );
};

VpStripePaymentMethod.propTypes = {
  onUpdateClick: PropTypes.func.isRequired,
  onClose: PropTypes.func
};

export default VpStripePaymentMethod;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/Stripe/VpStripePaymentMethod.jsx